import React from 'react';
import SoundBowlImg from '../../imgs/sound_bath.jpg';
import SoundBellImg from '../../imgs/sound_bath2.jpg';
import CacaoImg from '../../imgs/cacao.jpg';

const CacaoSoundBath: React.FC = () => {
  return (
    <div className="min-h-screen bg-lighttan pt-28">
        <h1 className="text-4xl font-bold text-darkgreentext mb-12 text-center">
          Cacao Ceremony with Breathwork and Sound Bath
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 px-4">
            <img
            src={SoundBowlImg}
            alt="Sound Bowl"
            className="w-full h-96 object-cover rounded-lg shadow-lg"
            />
            <img
            src={CacaoImg}
            alt="Cacao"
            className="w-full h-96 object-cover rounded-lg shadow-lg"
            />
            <img
            src={SoundBellImg}
            alt="Gong"
            className="w-full h-96 object-cover rounded-lg shadow-lg"
            />
        </div>

      <div className="max-w-4xl mx-auto px-8 py-16 text-center">
        <p className="text-xl text-darkgreentext leading-relaxed">
          Sean pairs his breath work instruction with a Cacao Ceremony by Shandell Pino of Inner Light Academy.  
          Concluded with a healing Sound Bath.
        </p>
      </div>
      <div className="flex justify-center pb-8">
        <a
          href="https://calendly.com/seanmotiv8living/cacao-ceremony-with-breathwork-and-sound-bath?back="
          className="px-6 py-3 bg-darkgreentext text-white rounded-lg font-bold text-xl hover:bg-greenbutton transition"
        >
          Sign Up Now
        </a>
      </div>
    </div>
  );
};

export default CacaoSoundBath;
